<script>
    export let title = 'Sección';
    export let subtitle = 'Opcional';

    export let isOpen = false;

    function toggleExpand() {
        isOpen = !isOpen;
    }
</script>

<div
    class="collapsible-header pure-g align-items-center m-b-25"
    on:click={toggleExpand}
    on:keypress={toggleExpand}
    style="cursor: pointer;"
>
    <div class="pure-u-2-3">
        <div class="h2 text-fs-20 fw-semibold">
            {title}
        </div>
    </div>
    <div class="pure-u-1-3 align-items-center justify-content-end text-right">
        <span class="m-b-0">{subtitle}</span>
        <svg
            class="m-l-15 icon"
            aria-hidden="true"
            style="transform: rotate({isOpen
                ? ''
                : '-'}90deg); transition: transform 0.2s ease-in-out;"
        >
            <use xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
            ></use>
        </svg>
    </div>
</div>

{#if isOpen}
    <div class="collapsible-content">
        <slot></slot>
    </div>
{/if}

<style>
    .collapsible-content {
        padding: 10px;
        background: #f9f9f9;
        border-radius: 5px;
    }

    .d-flex {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
</style>
